import React from 'react';
import { useParams } from 'react-router-dom';
import CommentRecords from './Comment/CommentRecords';

const CustomerDetailsComment = () => {
  const { customerId } = useParams<{ customerId: string}>();
  return (
    <div>
      <CommentRecords defaultUrl="comments" toggleStorageId="customer-comment-table-col" id={customerId} />

    </div>
  );
};
export default CustomerDetailsComment;
